export const PAYOUT_PAGE_SIZE = 50;

export const PAYOUTS_TABS = {
  PAYMENTS: "PAYMENTS",
  TRANSACTIONS: "TRANSACTIONS",
};

export const PAYOUT_PAGE_TABS = [
  { key: PAYOUTS_TABS.PAYMENTS, label: "Payments" },
  { key: PAYOUTS_TABS.TRANSACTIONS, label: "Transactions" },
];

export const PAYMENT_STATUS_FILTERS = [
  { key: "upcoming", label: "Upcoming" },
  { key: "paid", label: "Paid" },
];

export const TRANSACTION_STATUS_FILTERS = [
  { key: "invoices", label: "Invoices" },
  { key: "return_notes", label: "Return notes" },
  { key: "debit_note", label: "Debit note" },
  { key: "other", label: "Other" },
];

export const PAYMENT_STATUS_CODES = {
  upcoming: ["PENDING", "QUEUED_FOR_PAYOUT", "FAILED"],
  paid: ["PAID"],
};

export const TRANSACTION_TYPE_CODES = {
  invoices: "GRN_COMPLETE",
  return_notes: "PRN",
  debit_note: "DN",
};

export const OTHER_EXCLUDABLE_TYPES = ["GRN_COMPLETE", "PRN", "DN"];

export const FROM_ENTITY = { id: "HYPERPURE", type: "BUSINESS" };
export const TO_ENTITY_TYPE = "VENDOR";
